/**
 * Current time as unix seconds — the scale the offers API uses for reveal
 * instants (`showVenueOnEventPageAt`, `revealAddressToTicketHoldersAt`). One
 * place so every derivation reads "now" the same way.
 */
export const nowUnix = (): number => Math.floor(Date.now() / 1000);
